import ProductCard from '../shop/ProductCard';
import LoadingBottles from './LoadingBottles';

export default function SearchProductGrid({
  products = [],
  isSearching,
  searchTerm,
  selectedSuggestion,
  showInitialState = false,
  onProductClick
}) {
  // Loading state - Botellas bailarinas centradas
  if (isSearching) {
    return (
      <div className="flex items-center justify-center h-full">
        <LoadingBottles />
      </div>
    );
  }

  // Initial state - Solo botellas centradas, sin texto extra
  if (showInitialState) {
    return (
      <div className="flex items-center justify-center h-full">
        <LoadingBottles />
      </div>
    );
  }

  // Empty state - searched but no results
  if (products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full py-20 px-4 text-center">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#CCC"
          strokeWidth="1.5"
          className="mb-4"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <p className="text-base text-[#666] font-light mb-2">
          No se encontraron productos
        </p>
        {(searchTerm || selectedSuggestion) && (
          <p className="text-sm text-[#999] font-light">
            Intenta con otros términos de búsqueda
          </p>
        )}
      </div>
    );
  }

  // Products grid - Same style as shop ProductGrid
  return (
    <div className="py-4 md:py-6">
      {/* Results count */}
      <div className="mb-4 px-4 md:px-6">
        <p className="text-sm text-[#666] font-light">
          {products.length} {products.length === 1 ? 'producto encontrado' : 'productos encontrados'}
          {searchTerm && <span className="text-[#999]"> para "{searchTerm}"</span>}
        </p>
      </div>

      {/* Grid - Matching ProductGrid layout exactly */}
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-[var(--phys-snow)] border-r border-b border-[var(--phys-frost)] h-full"
            onClick={(e) => {
              // Si el click fue en un link al producto, cerrar el modal
              const link = e.target.closest('a[href*="/products/"]');
              if (link && onProductClick) {
                onProductClick();
              }
            }}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  );
}
